import { ColorScheme } from "./types";

const DEFAULT_COLORS = [
  "#4285F4",
  "#EA4335",
  "#FBBC05",
  "#34A853",
  "#8AB4F8",
  "#F28B82",
  "#FDE293",
  "#81C995",
  "#5F6368",
  "#DADCE0",
  "#673AB7",
  "#3F51B5",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFC107",
  "#FF9800",
  "#FF5722"
];

export class ColorGenerator implements ColorScheme {
  private colorMap: Map<string, string> = new Map();
  private categoryColorMap: Map<string, Map<string, string>> = new Map();
  private nextColorIndex = 0;

  constructor(private colors: string[] = DEFAULT_COLORS) {}

  public getColorForLabel(label: string, categoryName?: string): string {
    if (categoryName) {
      if (!this.categoryColorMap.has(categoryName)) {
        this.categoryColorMap.set(categoryName, new Map());
      }

      const categoryColors = this.categoryColorMap.get(categoryName);

      if (categoryColors) {
        if (!categoryColors.has(label)) {
          categoryColors.set(
            label,
            this.colors[this.nextColorIndex % this.colors.length]
          );
          this.nextColorIndex++;
        }

        const color = categoryColors.get(label);
        return color || this.colors[0];
      }

      return this.colors[0];
    }

    if (!this.colorMap.has(label)) {
      this.colorMap.set(
        label,
        this.colors[this.nextColorIndex % this.colors.length]
      );
      this.nextColorIndex++;
    }

    const color = this.colorMap.get(label);
    return color || this.colors[0];
  }

  public reset(): void {
    this.colorMap.clear();
    this.categoryColorMap.clear();
    this.nextColorIndex = 0;
  }
}
